(() => {
  const STORAGE_KEY = 'am_popup_dismissed';
  const DELAY_MS = 8000;

  if (localStorage.getItem(STORAGE_KEY)) return;
  if (window.Shopify && Shopify.designMode) return;

  const popup = document.getElementById('EmailPopup');
  if (!popup) return;

  function show() {
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    popup.querySelector('.email-popup__input')?.focus();
  }

  function dismiss() {
    popup.style.display = 'none';
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, Date.now());
  }

  // Trigger: timed delay
  const timer = setTimeout(show, DELAY_MS);

  // Trigger: exit-intent (desktop only — mouseleave toward top of viewport)
  document.addEventListener('mouseout', function onExit(e) {
    if (e.clientY < 10) {
      clearTimeout(timer);
      show();
      document.removeEventListener('mouseout', onExit);
    }
  });

  // Close: X button
  popup.querySelector('.email-popup__close')?.addEventListener('click', dismiss);

  // Close: backdrop click
  popup.addEventListener('click', (e) => {
    if (e.target === popup) dismiss();
  });

  // Close: Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.style.display === 'flex') dismiss();
  });

  // AJAX form submission — no page reload
  const form = popup.querySelector('form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('.email-popup__submit');
      const errorEl = document.getElementById('EmailPopup-error');
      submitBtn.textContent = 'Submitting...';
      submitBtn.disabled = true;
      errorEl.style.display = 'none';

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' },
      })
        .then((res) => {
          if (res.ok || res.status === 200 || res.status === 302) {
            localStorage.setItem(STORAGE_KEY, Date.now());
            document.getElementById('EmailPopup-form').style.display = 'none';
            document.getElementById('EmailPopup-success').style.display = 'block';
          } else {
            throw new Error('signup_failed');
          }
        })
        .catch(() => {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.style.display = 'block';
          submitBtn.textContent = 'Unlock My Discount';
          submitBtn.disabled = false;
        });
    });
  }
})();
